export function storeMergedDatalocallyById(data, bId) {
  const fetchedData = JSON.parse(sessionStorage.getItem("mergedTagsData"));

  // here we should update the merged tags data.if older than 180 days.
  console.log("data to be stored", data);

  const newData = fetchedData.map((item) => {
    if (item._id == bId) {

      let obj = {
        _id: item._id,
        mergedFoodTagsData: data,
      };
      return obj;
    } else return item;
  });

  sessionStorage.setItem("mergedTagsData", JSON.stringify(newData));
}

export function deleteOlderMergedTags(data) { 
  // console.log("data before deletion", data);
  let deleteOlderThan = 180;

  let currentDate = new Date().getTime();
  let expiryDate = new Date(currentDate - deleteOlderThan * 24 * 60 * 60 * 1000).getTime();
  // console.log("expiry date", new Date(expiryDate));
  let newData = data.filter((item) => {
    // console.log("checking item for deletion", item.creationDate);
    //  console.log("item date", new Date(item.creationDate));
    if (item?.creationDate > expiryDate) {
      // console.log("deleting item", item,new Date(item.creationDate));
      return true;
    } else return false; 
  })

  // console.log("deleting older merged tags if any");
  // console.log("data after deletion", newData);
  return newData;

}
